const handleCompleteActionFormActions = {
  confirm: '¿Realmente quiere completar esta acción?',
  title: 'ACCIÓN COMPLETA',
  newStatus: 'Concluido',
  inputError: 'Se requiere un mensaje de finalización',
};

export default handleCompleteActionFormActions;
